module.exports = __webpack_public_path__ + "img/Pellets-Sackware-Loose-Ware.f691c33.webp";